import { DefaultAuthorizationForPaymentOnFile } from "../../../domain/invoicing/settings/invoicingSettings"
import SwitchWithDescription from "../../common/SwitchWithDescription"
import VSpace from "../../common/VSpace"
import SettingsTitledCard from "../SettingsTitledCard"

type Props = {
  settings: DefaultAuthorizationForPaymentOnFile
  onUpdate: (settings: DefaultAuthorizationForPaymentOnFile) => void
}

const PaymentMethodOnFileSettingsCard = ({ settings, onUpdate }: Props) => {
  return <SettingsTitledCard
    title="Payment Methods on File Settings"
    description="Set the behavior for how customers see and use the payment authorization option during checkout."
  >
    <VSpace size="large">
      <SwitchWithDescription
        checked={settings.showAuthorizePaymentOnFile}
        label="Request Payment Method on File"
        description="Display the option for customers to authorize saving their payment method for future use."
        onClick={() => onUpdate({
          ...settings,
          showAuthorizePaymentOnFile: !settings.showAuthorizePaymentOnFile,
          requireAuthorizePaymentOnFile: !settings.showAuthorizePaymentOnFile && settings.requireAuthorizePaymentOnFile
        })}
      />
      {settings.showAuthorizePaymentOnFile && <div style={{marginLeft: 50, borderLeft: '1px solid #00000026', paddingLeft: 12}}>
        <SwitchWithDescription
          checked={settings.requireAuthorizePaymentOnFile}
          label="Require Payment Method on File"
          description="Make it required for customers to authorize saving their payment method for future use."
          onClick={() => onUpdate({...settings, requireAuthorizePaymentOnFile: !settings.requireAuthorizePaymentOnFile})}
        />
      </div>}
    </VSpace>
  </SettingsTitledCard>
}

export default PaymentMethodOnFileSettingsCard